var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 482,
    viewBox: "0 0 531 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 0H0V196.6H38.1V0Z",
    transform: "translate(309 177.8)",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 0H0V148.8H35.2V0Z",
    transform: "translate(329 215.9)",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.2 78.9C171.2 78.9 81.9 97.8 0 0",
    transform: "translate(235.8 242)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162 96.4C162 96.4 71.2 105.9 0 0",
    transform: "translate(235.9 242)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151 112.8C151 112.8 59.7 112.7 0 0",
    transform: "translate(235.9 242)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.4 128C138.4 128 47.6 118.4 0 0",
    transform: "translate(235.9 241.9)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.3 141.7C124.3 141.7 35 122.7 0 0",
    transform: "translate(235.8 242)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 153.9C108.8 153.9 22 125.6 0 0",
    transform: "translate(235.9 242)",
    stroke: "#59ABEE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L9.5 92.1L68.1 147.5L87.7 134.3L21.3 86.3L0 0Z",
    transform: "translate(235.9 242)",
    fill: "url(#paint2_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1 0H0V80.3H34.1V0Z",
    transform: "translate(343.201 272.1)",
    fill: "url(#paint3_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.80002H5.80002V0Z",
    transform: "translate(347.801 280.4)",
    fill: "url(#paint4_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.80002H5.80002V0Z",
    transform: "translate(357.401 280.4)",
    fill: "url(#paint5_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79999 0H0V5.80002H5.79999V0Z",
    transform: "translate(367.001 280.4)",
    fill: "url(#paint6_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.79999H5.80002V0Z",
    transform: "translate(347.801 292.6)",
    fill: "url(#paint7_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.79999H5.80002V0Z",
    transform: "translate(357.401 292.6)",
    fill: "url(#paint8_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79999 0H0V5.79999H5.79999V0Z",
    transform: "translate(367.001 292.6)",
    fill: "url(#paint9_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.80002H5.80002V0Z",
    transform: "translate(347.801 304.8)",
    fill: "url(#paint10_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.80002H5.80002V0Z",
    transform: "translate(357.401 304.8)",
    fill: "url(#paint11_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79999 0H0V5.80002H5.79999V0Z",
    transform: "translate(367.001 304.8)",
    fill: "url(#paint12_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.79999H5.80002V0Z",
    transform: "translate(347.801 317)",
    fill: "url(#paint13_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80002 0H0V5.79999H5.80002V0Z",
    transform: "translate(357.401 317)",
    fill: "url(#paint14_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79999 0H0V5.79999H5.79999V0Z",
    transform: "translate(367.001 317)",
    fill: "url(#paint15_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 0H0V44.5H30.9V0Z",
    transform: "translate(335 326.9)",
    fill: "url(#paint16_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30002 10.3H0V2.59998C0 1.09998 1.20001 0 2.60001 0C4.10001 0 5.20001 1.19998 5.20001 2.59998V10.3H5.30002Z",
    transform: "translate(341.9 333.2)",
    fill: "url(#paint17_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29999 10.3H0V2.59998C0 1.09998 1.20001 0 2.60001 0C4.10001 0 5.19998 1.19998 5.19998 2.59998V10.3H5.29999Z",
    transform: "translate(353.601 333.2)",
    fill: "url(#paint18_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30002 10.3H0V2.60001C0 1.10001 1.20001 0 2.60001 0C4.10001 0 5.20001 1.20001 5.20001 2.60001V10.3H5.30002Z",
    transform: "translate(341.9 346.4)",
    fill: "url(#paint19_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 0H0V71.5H39.5V0Z",
    transform: "translate(377.3 298.6)",
    fill: "url(#paint20_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20001 13.9H0V3.10001C0 1.40001 1.40001 0 3.10001 0C4.80001 0 6.20001 1.40001 6.20001 3.10001V13.9V13.9Z",
    transform: "translate(383 303.9)",
    fill: "url(#paint21_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20001 13.9H0V3.10001C0 1.40001 1.40001 0 3.10001 0C4.80001 0 6.20001 1.40001 6.20001 3.10001V13.9V13.9Z",
    transform: "translate(393.9 303.9)",
    fill: "url(#paint22_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20001 13.9H0V3.09998C0 1.39998 1.40001 0 3.10001 0C4.80001 0 6.20001 1.39998 6.20001 3.09998V13.9V13.9Z",
    transform: "translate(383 322.2)",
    fill: "url(#paint23_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20001 13.9H0V3.10001C0 1.40001 1.40001 0 3.10001 0C4.80001 0 6.20001 1.40001 6.20001 3.10001V13.9V13.9Z",
    transform: "translate(383 340.4)",
    fill: "#171D2C",
    stroke: "#FFC809",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20001 13.9H0V3.10001C0 1.40001 1.40001 0 3.10001 0C4.80001 0 6.20001 1.40001 6.20001 3.10001V13.9V13.9Z",
    transform: "translate(393.9 340.4)",
    fill: "#171D2C",
    stroke: "#FFC809",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20001 13.9H0V3.10001C0 1.40001 1.40001 0 3.10001 0C4.80001 0 6.20001 1.40001 6.20001 3.10001V13.9V13.9Z",
    transform: "translate(404.9 340.4)",
    fill: "#171D2C",
    stroke: "#FFC809",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9 0H0V9.39999H24.9V0Z",
    transform: "translate(384.6 289.2)",
    fill: "url(#paint24_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 13.9H0V5.19998C0 2.29998 2.30001 0 5.20001 0C8.10001 0 10.4 2.29998 10.4 5.19998V13.9H10.3Z",
    transform: "translate(391.9 284.7)",
    fill: "url(#paint25_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 0H0V29.7H26.9V0Z",
    transform: "translate(228.3 389.5)",
    fill: "url(#paint26_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0H0V50.6H31.5V0Z",
    transform: "translate(241.7 366.5)",
    fill: "url(#paint27_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3 0H0V42.6H67.3V0Z",
    transform: "translate(464.101 194.6)",
    fill: "url(#paint28_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3 2.39999V33.6H0C0 15 15.1 0 33.6 0C38.1 0 42.4 0.799994 46.3 2.39999Z",
    transform: "translate(485.101 161)",
    fill: "url(#paint29_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8 0V11.2H78.5V0H67.3V11.2H56.1V0H44.9V11.2H33.7V0H22.5V11.2H11.3V0H0V11.2V92H101V11.2V0H89.8Z",
    transform: "translate(430.4 220.4)",
    fill: "url(#paint30_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 0H0V80.7H25.1V0Z",
    transform: "translate(441.8 150.9)",
    fill: "url(#paint31_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 0H0V8.10001H17.8V0Z",
    transform: "translate(445.4 142.7)",
    fill: "url(#paint32_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89999 0C3.99999 0 0 4 0 8.9V21.6H17.8V8.9C17.8 4 13.9 0 8.89999 0Z",
    transform: "translate(445.4 121.1)",
    fill: "url(#paint33_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39999 12.9H32.5V0H0L7.39999 12.9Z",
    transform: "translate(434.4 166)",
    fill: "url(#paint34_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90.5H0L12 12.1C13.1 5.20001 19 0 26 0C33 0 39 5.10001 40 12.1L52 90.5Z",
    transform: "translate(406.4 233.5)",
    fill: "url(#paint35_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C2.4 0 0 2.5 0 5.5V22.5H11.1V5.5C11 2.5 8.5 0 5.5 0Z",
    transform: "translate(426.9 293.1)",
    fill: "url(#paint36_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 0L0 14.2L37.3 37.3L14.1 0Z",
    transform: "translate(395.1 209.3)",
    fill: "url(#paint37_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 23.2L23.2 37.3L0 0L37.3 23.2Z",
    transform: "translate(432.4 246.6)",
    fill: "url(#paint38_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.2L14.1 37.3L37.3 0L0 23.2Z",
    transform: "translate(395.1 246.6)",
    fill: "url(#paint39_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 0L37.3 14.2L0 37.3L23.2 0Z",
    transform: "translate(432.4 209.3)",
    fill: "url(#paint40_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60001 13.2C10.2451 13.2 13.2 10.2451 13.2 6.60001C13.2 2.95493 10.2451 0 6.60001 0C2.95493 0 0 2.95493 0 6.60001C0 10.2451 2.95493 13.2 6.60001 13.2Z",
    transform: "translate(425.8 240)",
    fill: "#59ABEE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 21.1C72.8 24.3 70.2 26.9 67 26.9C66.9 26.9 66.8 26.9 66.7 26.9C65.9 30.9 63 34 59.2 35.3C58.1 35.7 56.9 35.9 55.6 35.9C51.5 35.9 48 33.8 46 30.5C42.7 33.8 38.2 35.9 33.2 35.9C27.6 35.9 22.5 33.3 19.2 29.2C17.2 31.2 14.4 32.4 11.3 32.4C5 32.4 0 27.3 0 21.1C0 19.7 0.199997 18.4 0.699997 17.2C2.3 12.9 6.4 9.7 11.3 9.7C13.2 9.7 15 10.2 16.6 11C19.3 4.5 25.7 0 33.1 0C41.7 0 49 6.1 50.6 14.3C52.1 13.6 53.7 13.2 55.5 13.2C58.5 13.2 61.3 14.4 63.3 16.4C64.3 15.7 65.5 15.2 66.8 15.2C70.2 15.3 72.8 17.9 72.8 21.1Z",
    transform: "translate(195.7 148)",
    fill: "url(#paint41_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 10.5C66.9 10.5 65 11.1 63.5 12.2C60.5 5 53.3 0 45.1 0C38.3 0 32.3 3.4 28.6 8.5C26.8 7.6 24.8 7.1 22.6 7.1C17.6 7.1 13.3 9.9 11.1 14C9.99998 13.3 8.59998 12.8 7.19998 12.8C3.19998 12.8 0 16 0 20C0 24 3.19998 27.2 7.19998 27.2C8.69998 27.2 9.99998 26.8 11.1 26C13.3 30.1 17.6 32.9 22.6 32.9C24.7 32.9 26.8 32.4 28.6 31.5C32.2 36.7 38.2 40 45 40C53.3 40 60.4 35 63.5 27.8C65 28.9 66.9 29.5 68.9 29.5C74.2 29.5 78.5 25.2 78.5 19.9C78.5 14.8 74.2 10.5 68.9 10.5Z",
    transform: "translate(399.7)",
    fill: "url(#paint42_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M531.4 0V201.9H0C91.4 188.3 234.5 145.5 328.7 85C443.9 10.9 531.4 0 531.4 0Z",
    transform: "translate(0 279.6)",
    fill: "url(#paint43_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-99.4771 67.6317) scale(237.103) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-55.7481 49.6984) scale(146.67) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8695 242.487) scale(181.011) rotate(-120.059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-26.1152 64.665) scale(86.3797) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.051 79.0236) scale(79.782) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.0163 79.0236) scale(79.782) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-36.9813 79.0236) scale(79.7815 79.782) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.051 66.8233) scale(79.782 79.7815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.0163 66.8233) scale(79.782 79.7815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-36.9813 66.8233) scale(79.7815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.051 54.6236) scale(79.782) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.0163 54.6236) scale(79.782) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-36.9813 54.6236) scale(79.7815 79.782) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.051 42.4233) scale(79.782 79.7815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-37.0163 42.4233) scale(79.782 79.7815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-36.9813 42.4233) scale(79.7815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.9931 37.1984) scale(40.8388) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-18.3546 40.5567) scale(42.0001 42) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-18.2929 40.5567) scale(41.9999) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-18.3546 27.3567) scale(42.0001) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-18.5333 56.915) scale(76.5016) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-32.6426 69.8567) scale(71.4649 71.4648) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-32.615 69.8567) scale(71.4649 71.4648) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-32.6426 51.5567) scale(71.4649 71.4648) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.246 13.8984) scale(24.343) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.2237 0.9748) scale(12.0232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-12.5611 23.5984) scale(52.0213) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-20.3958 33.9317) scale(72.348) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.6262 54.8317) scale(74.5086) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.55175 42.765) scale(39.1719) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.74795 60.6984) scale(116.508) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-29.8681 79.865) scale(84.8141) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.3111 19.2234) scale(26.5002) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.47996 30.5734) scale(28.8379) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.3561 29.0525) scale(43.1646) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-32.6748 94.265) scale(117.335) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.17825 30.3234) scale(25.3421) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8531 53.1975) scale(44.2581) rotate(-135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9421 -15.6065) scale(45.0494) rotate(42.9011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1183 15.6978) scale(43.1071) rotate(135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15.0893 22.0901) scale(42.8988) rotate(-45)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.4824 37.7825) scale(169.855) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-38.6462 40.385) scale(155.804) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.178 143.832) scale(275.016) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.e469a2a5130e453d408adabb95831470.svg";
export { ForwardRef as ReactComponent };